import { ref, reactive } from '@vue/composition-api'

export default function useVendorList(ctx) {
  const columns = [
    {
      key: 'additionalData',
      label: 'locations',
    },
    {
      key: 'name',
    },
    {
      key: 'active',
    },
    {
      key: 'emails',
    },
    {
      key: 'phoneNumber',
      label: 'Phone Number',
    },
    {
      key: 'pointOfContact',
      label: 'Point Of Contact',
    },
    {
      key: 'maxChargeAmount',
      label: 'Max Charge Amount',
    },
    {
      key: 'createdAt',
      label: 'Created At',
    },
    {
      key: 'Actions',
    },
  ]
  const vendors = ref([])
  const vendorsLoading = ref(false)
  const fetchVendors = async () => {
    try {
      vendorsLoading.value = true
      const res = await ctx.root.$store.dispatch('vendors/fetchVendors')
      vendors.value = res
    } finally {
      vendorsLoading.value = false
    }
  }

  const confirmationData = reactive({
    id: 'confirmation-status',
    title: '',
    onSubmit: () => { },
  })
  const handleChangeStatus = (status, vendor) => {
    if (status === 'activate') {
      confirmationData.title = `Activate ${vendor.name}`
    } else {
      confirmationData.title = `Deactivate ${vendor.name}`
    }
    confirmationData.onSubmit = async () => {
      await ctx.root.$store.dispatch('vendors/patchVendor', {
        id: vendor.id,
        data: {
          vendorType: vendor.vendorType,
          active: !vendor.active,
        },
      })
    }
    ctx.root.$bvModal.show('confirmation-status')
  }

  const currentVendorLocations = ref([])
  const displayVendorLocations = locations => {
    currentVendorLocations.value = locations
    ctx.root.$bvModal.show('vendor-locations-viewer')
  }
  fetchVendors()

  return {
    columns,
    vendors,
    vendorsLoading,
    fetchVendors,
    confirmationData,
    handleChangeStatus,
    currentVendorLocations,
    displayVendorLocations,
  }
}
